import { render, staticRenderFns } from "./DropdownBase.vue?vue&type=template&id=421566b8"
import script from "./DropdownBase.vue?vue&type=script&lang=js"
export * from "./DropdownBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports